import { render, staticRenderFns } from "./uploadQuote.vue?vue&type=template&id=89e31c4e&"
import script from "./uploadQuote.vue?vue&type=script&lang=js&"
export * from "./uploadQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports